module.exports = __webpack_public_path__ + "assets/img/27_1255_big.ff6af310.jpg";